//控件的方向值
//设备状态
export const deviceAuthStatus = {
  noAuth:0,
  partAuth: 1,
  allAuth: 2
}